type CallbackType = {
  fill: string
  width: string
  height: string
  title: string
}

function Callback(props: CallbackType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'callback'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 19 23'
      fill='none'
    >
      <title>{title}</title>
      <path
        d='M3.3125 4.3125H17.6875'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
      <path
        d='M3.3125 17.7305H17.6875'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
      <path
        d='M3.3125 8.62565V2.87565C3.3125 2.36732 3.51443 1.87981 3.87388 1.52036C4.23332 1.16092 4.72084 0.958984 5.22917 0.958984H15.7708C16.2792 0.958984 16.7667 1.16092 17.1261 1.52036C17.4856 1.87981 17.6875 2.36732 17.6875 2.87565V20.1257C17.6875 20.634 17.4856 21.1215 17.1261 21.4809C16.7667 21.8404 16.2792 22.0423 15.7708 22.0423H5.22917C4.72084 22.0423 4.23332 21.8404 3.87388 21.4809C3.51443 21.1215 3.3125 20.634 3.3125 20.1257V13.4173'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M0.4375 11.0215H10.5'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
      <path
        d='M7.625 8.14648L10.5 11.0215L7.625 13.8965'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default Callback
